export const QB_HOSTNAME = process.env.REACT_APP_QB_HOSTNAME || '';
export const QB_API = process.env.REACT_APP_QB_API || '';
export const QB_APP_TOKEN = process.env.REACT_APP_QB_APPTOKEN || '';
export const QB_USERTOKEN = process.env.REACT_APP_QB_USERTOKEN || '';
export const QB_REALM = process.env.REACT_APP_QB_REALM || '';
export const NP_API_KEY = process.env.REACT_APP_NP_API_KEY || '';
export const NP_API = process.env.REACT_APP_NP_API || '';
export const API = process.env.REACT_APP_API || ''